import { Tooltip, UIText2 } from '@cian/ui-kit';
import * as React from 'react';
import { Detail } from '../Detail';
import * as styles from './Regions.css';

interface IRegionsProps {
  title: string;
  firstRegionNames: Array<string>;
  restRegionNames: Array<string>;
}

export const Regions = (props: IRegionsProps) => {
  const { title, firstRegionNames, restRegionNames } = props;

  return (
    <Detail title={title}>
      <UIText2 display="inline" color="black_100">
        {firstRegionNames.join(', ')}
      </UIText2>

      {restRegionNames.length > 0 && (
        <Tooltip placement="top-end" theme="white" title={restRegionNames.join(', ')}>
          <span className={styles['rest_regions']}>+{restRegionNames.length}</span>
        </Tooltip>
      )}
    </Detail>
  );
};
